import { render, staticRenderFns } from "./InputAssestment.vue?vue&type=template&id=de865ee4&scoped=true"
import script from "./InputAssestment.vue?vue&type=script&lang=js"
export * from "./InputAssestment.vue?vue&type=script&lang=js"
import style0 from "./InputAssestment.vue?vue&type=style&index=0&id=de865ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de865ee4",
  null
  
)

export default component.exports